import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as UitzendbureauIcon } from './uitzendbureau.svg';

export const Uitzendbureau = IconHOC(UitzendbureauIcon);
